import { Controller } from "@hotwired/stimulus"
import TagItemBuilder from "../concern/tag_item"

const MAX_TAGS = 30

export default class extends Controller {
  static targets = ["tagItem", "container", "template"]

  addNewTag() {
    if (this.containerTarget.children.length > MAX_TAGS) {
      console.error("too many tags")
      return
    }
    const clone = this.templateTarget.content.cloneNode(true)
    this.containerTarget.appendChild(clone)
  }

  removeNewTag(event) {
    this.#getTagItem(event.target).delete()
  }

  removeSavedTag(event) {
    // this.#getTagItem(event.target).delete()
  }

  restoreTag(event) {
    this.#getTagItem(event.target).restore()
  }

  handleBlur(event) {
    this.#getTagItem(event.target).handleEditableBlur()
  }

  handleEnter(event) {
    if (!this.#isEnterKey(event)) return
    event.preventDefault()
    this.#moveToNextOrCreateTag(this.#getTagItem(event.target))
  }

  handleInput(event) {
    this.#getTagItem(event.target).handleEditableInput()
  }

  handleDisplayClick(event) {
    this.#getTagItem(event.target).handleDisplayClick()
  }

  // Private methods
  #getTagItem(element) {
    return TagItemBuilder.build(element.closest('[role="tag-item"]'))
  }

  #isEnterKey(event) {
    return event.key === "Enter" && !event.isComposing
  }

  #moveToNextOrCreateTag(tagItem) {
    const nextTagElem = this.#findNextTagElement(tagItem)
    if (nextTagElem) {
      nextTagElem.querySelector('[js-tag-role="editable"]')?.focus()
    } else {
      this.addNewTag()
      this.tagItemTargets.at(-1).querySelector('[js-tag-role="editable"]')?.focus()
    }
  }

  #findNextTagElement(currentTagItem) {
    return this.#sliceTagAfter(currentTagItem).find((item) => !TagItemBuilder.build(item).isDeleted)
  }

  #sliceTagAfter(tagItem) {
    // tagItem 이 'TagItem' 인스턴스라서, tagItem.element가 원본 element

    const currentIndex = this.tagItemTargets.indexOf(tagItem.element)
    if (currentIndex === -1) {
      console.error("tagItem not found", tagItem)
      return []
    }
    return [...this.tagItemTargets].slice(currentIndex + 1)
  }
}
